import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const PUBLISH_EMAIL = createAsyncActionTypes('PUBLISH_EMAIL');
export const FETCH_OVERSIZED_COMMON_MESSAGE = createAsyncActionTypes('FETCH_OVERSIZED_COMMON_MESSAGE');